import { Skeleton } from '@/components/ui';

function ChildCardSkeleton() {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-4">
      <Skeleton
        variant="circular"
        className="w-10 h-10 shrink-0"
      />
      <div className="flex-1 flex flex-col gap-1.5">
        <Skeleton className="h-4 w-24" />
        <div className="flex gap-2">
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-4 w-28" />
        </div>
      </div>
      <div className="flex gap-1">
        <Skeleton className="h-8 w-8 rounded-md" />
        <Skeleton className="h-8 w-8 rounded-md" />
      </div>
    </div>
  );
}

export function SettingsChildrenSkeleton() {
  return (
    <div className="flex flex-col gap-3 px-5 py-5">
      <ChildCardSkeleton />
      <ChildCardSkeleton />
    </div>
  );
}
